import { Editor, TLPageId, TLShape, TLUnknownShape } from "tldraw"
import { LDPage } from "../../shared/LDPage"
import { LDGroupShape, LDShape } from "../../shared/LDShape"
import { CustomDrawShape } from "../../shared/CustomDrawShape"
import { LDTextShape } from "../../shared/LDTextShape"
import { LDGeoShape } from "../../shared/LDGeoShape"
import { Layers3 } from "lucide-react"
import { Env, Expr } from "../../shared/Expr"

/**
 * Get the parameter values for this shape by grabbing from it's ancestors
 * @param shape
 * @param editor
 * @returns
 */
export function flattenParams(
  shape: CustomDrawShape | LDTextShape | LDGroupShape | LDGeoShape,
  editor: Editor,
) {
  const pageId = LDShape.getSourcePageId(editor, shape)
  const page = editor.getPage(pageId) as LDPage
  const targetPage = editor.getPage(pageId) as LDPage
  const parameterValues = {
    ...(editor.getShape(shape.parentId) as LDGroupShape)?.props.parameterValues,
  }
  let parent: TLUnknownShape | LDPage =
    (editor.getShape((shape as TLUnknownShape).parentId) as
      | LDGroupShape
      | undefined) ??
    (editor.getPage((shape as TLUnknownShape).parentId as TLPageId) as LDPage)

  const params = {
    ...targetPage.meta.parameterValues,
    ...Object.fromEntries(
      Object.keys(parameterValues ?? {}).map((paramId) => {
        let sourcePage =
          editor.getShape(parent as LDShape) &&
          LDShape.getSourcePageId(editor, parent as LDShape)
        let layer =
          editor.getShape(parent as LDShape) &&
          LDShape.getLayerId(parent as LDShape)
        let layerOverrides =
          sourcePage &&
          layer &&
          (editor.getPage(sourcePage) as LDPage).meta.layers[layer]
            .layerOverrides
        let paramValue =
          (layerOverrides as Env)?.[paramId] ?? parameterValues?.[paramId]
        while (paramValue?.type === "ref") {
          parent =
            (editor.getShape((parent as TLUnknownShape).parentId) as
              | LDGroupShape
              | undefined) ??
            (editor.getPage(
              (parent as TLUnknownShape).parentId as TLPageId,
            ) as LDPage)
          sourcePage =
            editor.getShape(parent as LDShape) &&
            LDShape.getSourcePageId(editor, parent as LDShape)
          layer =
            editor.getShape(parent as LDShape) &&
            LDShape.getLayerId(parent as LDShape)
          layerOverrides =
            sourcePage &&
            layer &&
            (editor.getPage(sourcePage) as LDPage).meta.layers[layer]
              .layerOverrides

          paramValue =
            (layerOverrides as Env)?.[paramValue.id] ??
            (parent as LDGroupShape).props?.parameterValues[paramValue.id] ??
            (parent as LDPage).meta.parameterValues[paramValue.id]
        }
        return [paramId, paramValue]
      }),
    ),
  }
  return params
}
